import React, { useLayoutEffect, useMemo } from 'react';
import shareImg from 'src/assets/share.jpg';
import { CAN_USE_DOM, DOMAIN_URL, PAGE_TITLE } from 'src/constants/other';
import { useTranslation } from 'src/hooks/translations';
import { applyHeadTags, buildHeadTagDescriptors, headTagsToReactElements } from 'src/utils/head-tags';
import { useLocation } from 'react-router-dom';

interface Props {
  seo?: {
    title?: string;
    description?: string;
  };
  og?: {
    title?: string;
    description?: string;
    imageUrl?: string;
  };
  canonicalUrl?: string;
}

const Head = (props: Props) => {
  const { seo, og, canonicalUrl } = props;
  const { translate } = useTranslation('seo');
  const location = useLocation();
  const pageUrl = `${DOMAIN_URL}${location.pathname}${location.search}`;
  const SEO = {
    title: PAGE_TITLE,
    description: translate('description'),
    ...seo,
  };
  const OG = {
    title: PAGE_TITLE,
    description: translate('ogDescription'),
    imageUrl: shareImg,
    ...og,
  };

  const descriptors = useMemo(
    () =>
      buildHeadTagDescriptors({
        title: SEO.title,
        description: SEO.description,
        pageUrl,
        ogTitle: OG.title,
        ogDescription: OG.description,
        ogImageUrl: OG.imageUrl,
        canonicalUrl,
      }),
    [SEO.title, SEO.description, pageUrl, OG.title, OG.description, OG.imageUrl, canonicalUrl]
  );

  useLayoutEffect(() => {
    if (!CAN_USE_DOM) return;

    return applyHeadTags(descriptors);
  }, [descriptors]);

  if (CAN_USE_DOM) {
    return null;
  }

  return <>{headTagsToReactElements(descriptors)}</>;
};

export default Head;
